import $ from 'jquery'

/* @ngInject */
const mySaleDisplay = (
  $$sale,
  $timeout,
  $$wagon,
  $$axletree,
  $$piece,
  toaster,
  $$sterile,
  excelLoader,
  valueHandler,
  icons,
  computeWeight,
) => {
  return {
    restrict: 'E',
    scope: {
      mySale: '=',
    },
    template: require('./mySaleDisplay.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.$$wagon = $$wagon
      $scope.fieldsOptions = $$wagon.metadata.fields
      $scope.icons = icons

      $scope.displayBody = (wagonId, event) => {
        const state = !$scope.display[wagonId]
        $scope.display = {}
        $scope.display[wagonId] = state

        if (state) {
          $$sale.data.currentWagonId = wagonId
        } else {
          $$sale.data.currentWagonId = null
        }
      }

      $scope.tableHeaders = [
        'Numéro de wagon',
        'Essieu/Pièce/Stérile',
        'Restitués (kg)',
        'Ferraillés (kg)',
        'Poids (kg)',
        'Validé',
        'Certificat',
      ]

      $scope.options = {
        export: 'matter',
      }

      $scope.arrivalRadios = [{
        label: 'Diamètre',
        id: 'diameter',
        value: 'diameter',
      }, {
        label: 'Mesure relevée',
        id: 'matter',
        value: 'matter',
      },]

      $scope.goEditAxletrees = (_wagonId) => {
        $$axletree.go.edit(_wagonId)
      }

      $scope.goEditPieces = (_wagonId) => {
        $$piece.go.edit(_wagonId)
      }

      $scope.goEditSteriles = (_wagonId) => {
        $$sterile.go.edit(_wagonId)
      }

      $scope.displaySteriles = false
      $scope.displayPieces = false
      $scope.displayAxletrees = false

      $scope.getAxletreesWeight = computeWeight.getAxletreesWeight
      $scope.getSterilesWeight = computeWeight.getSterilesWeight
      $scope.getPiecesWeight = computeWeight.getPiecesWeight
      $scope.getWagonWeight = computeWeight.getWagonWeight
      $scope.getWagonsWeight = computeWeight.getWagonsWeight
      $scope.getScrapWeight = computeWeight.getScrapWeight
      $scope.getTotalPiecesWeight = computeWeight.getTotalPiecesWeight
      $scope.getTotalSterilesWeight = computeWeight.getTotalSterilesWeight
      $scope.getTotalAxletreesWeight = computeWeight.getTotalAxletreesWeight

      $scope.generateAxletreesCertificate = (_sale) => {
        excelLoader.scrapping.download(_sale, $scope.options)
          .then((message) => { })
          .catch((error) => {
            toaster.message(error, 'red')
            console.error(error)
          })
      }

      $scope.downloadDestruction = (_sale, _wagon, event) => {
        event.stopPropagation()
        excelLoader.destruction.download(_sale, _wagon)
          .then((message) => { })
          .catch((error) => {
            toaster.message(error, 'red')
            console.error(error)
          })
      }

      $scope.checkScrapping = async (wagon) => {
        try {
          const response = await $$wagon.request.checkScrapping(wagon.id, !wagon.checkScrapping)
          toaster.message(response.message, response.color)
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.goToGenerateBLWagons = () => {
        $$sale.go.generateBLWagons($scope.mySale.id)
      }

      $scope.goToGenerateBLEssieux = () => {
        $$sale.go.generateBLEssieux($scope.mySale.id)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

        $('.collapsible').collapsible()
      },
      post: (scope, element, attrs, ctrl) => {
        $timeout(() => {
          scope.display = {}
          if ($$sale.data.currentWagonId) {
            const element = $('#' + $$sale.data.currentWagonId)
            element.click()
            scope.display[$$sale.data.currentWagonId] = true
          }
          // $('.not-collapse').on('click', function (e) { e.stopPropagation() })
        })

        scope.scrapPieLabels = ['Poids des essieux ferraillés (kg)', 'Poids des essieux restitués (kg)', 'Poids des pièces (kg)', 'Poids des stériles (kg)',]
        scope.scrapPieColors = ['#888888', '#707070', '#BABABA', '#ed9711',]
        scope.scrapPieData = []

        scope.wagonPieLabels = ['Poids restant des wagons (kg)', 'Poids de la ferraille (kg)',]
        scope.wagonPieColors = ['#888888', '#707070',]
        scope.wagonPieData = []

        const computePies = (wagons) => {
          scope.scrapPieData = [
            scope.getTotalAxletreesWeight(wagons, 'Ferraillé'),
            scope.getTotalAxletreesWeight(wagons, 'Restitué'),
            scope.getTotalPiecesWeight(wagons),
            scope.getTotalSterilesWeight(wagons),
          ]

          scope.wagonPieData = [
            scope.getWagonsWeight(wagons),
            scope.getScrapWeight(wagons),
          ]
        }

        scope.$watch('mySale.wagons', (newValue, oldValue) => {
          if (newValue !== oldValue && valueHandler.isArray(newValue)) {
            computePies(newValue)
          }
        })
      },
    },
  }
}

export default mySaleDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/directives/display/mySaleDisplay.js